// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__16znB","info":"Note_info__1dCwR","note":"Note_note__21OQB","actions":"Note_actions__2DCIb"};